module.exports = __webpack_public_path__ + "static/media/typescript.234807da.png";